import Layout from '../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../Images/layout/news.jpg'
import GlobalLayout from '../Component/layout/global-layout'

const Video = () => {
    const { t } = useTranslation()
    return (
        <GlobalLayout
        title={`${t('video')} - ${t('supreme_court')} ${t('turkmenistan')}`}
        keywords="Wideo, Video, Kazyýet, Kazyyet barada"
    >
        <div className='mb-20'>
            <Layout
                title={t('news')}
                page={t('video')}
                layoutBgImg={layoutBgImg}
            />
            <div className='mt-8 media'>

                <p className='mb-8 text-primary font-bold 
                          dark:text-dark-text text-2xl'>
                    {t('video')}
                </p>

            </div>
        </div>
        </GlobalLayout>
    )
}

export default Video